<script setup lang="ts">
import type { NovaCalendarSlotProps } from './NovaCalendarSlot.types'

defineProps<NovaCalendarSlotProps>()
</script>

<template>
  <div
    :class="[
      'calendar-slot',
      {
        prev: calendarSlot.type === 'PREV',
        next: calendarSlot.type === 'NEXT',
        on: calendarSlot.isCheckedIn,
        today: calendarSlot.isToday,
      },
    ]"
  >
    <div class="inner">
      <span class="label">{{ calendarSlot.day }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.calendar-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;

  &.prev,
  &.next {
    opacity: 0.4;
  }

  &.today {
    > .inner {
      border: 2.81px solid #759ffd;
    }
  }

  &.on {
    > .inner {
      background: linear-gradient(0deg, #6e8eff 0%, #90d9fa 100%);

      > .label {
        color: $color-white;
      }
    }
  }

  > .inner {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48.38px;
    height: 48.38px;
    border-radius: 50%;

    @include mobile {
      width: 29.62px;
      height: 29.62px;
    }

    > .label {
      font-size: 25.31px;
      font-weight: 500;
      color: #7c86a2;
      line-height: 1;

      @include mobile {
        font-size: 15.5px;
      }
    }
  }
}
</style>
